import coreReducer from './coreSlice';
import firstFeatureReducer from '@/features/firstFeature/store/firstFeature.slice';
import secondFeatureReducer from '@/features/secondFeature/store/secondFeature.slice';
import sessionReducer from '@/features/session/store/sessionSlice';
import matchMakerReducer from '@/features/match-maker/store/match-maker.slice';
import materialDetailReducer from '@/features/match-maker/store/material-detail.slice';
import materialMatchSummaryReducer from '@/features/match-maker/store/material-match-summary.slice';
import materialSoftTagReducer from '@/features/match-maker/store/material-soft-tag.slice';
import productionPeriodReducer from '@/features/production-reporting/store/production-period.slice';
import facilityReducer from '@/features/production-reporting/store/facility.slice';
import productionReportReducer from '@/features/production-reporting/store/production-report.slice';
import productionOrderReducer from '@/features/production-reporting/store/production-order.slice';

const rootReducer = {
  reducer: {
    core: coreReducer,
    firstFeature: firstFeatureReducer,
    secondFeature: secondFeatureReducer,
    session: sessionReducer,
    matchMaker: matchMakerReducer,
    materialDetail: materialDetailReducer,
    materialMatchSummary: materialMatchSummaryReducer,
    materialSoftTag: materialSoftTagReducer,
    productionPeriod: productionPeriodReducer,
    facilities: facilityReducer,
    productionReport: productionReportReducer,
    productionOrder: productionOrderReducer,
  },
};

export default rootReducer;
